import SkeletonMUI from './SkeletonMUI';

export default SkeletonMUI;
